module.exports = __webpack_public_path__ + "static/shuttlevision-cctv-school-bus-ticket-hero-a73b2c4e17ebac275cfe406e9478360d.jpg";